import { gsap } from 'gsap'
import { deepMerge, getCubicCurve, getTargetOffsetTop } from 'js/utils/Utils'

import Common from 'js/_core/Common'

const defaults = {
  instanceName: 'sideStickySectionTextInViewAnimation',
  $names: {
    header: '[data-header]',
    section: '[data-anim="side-sticky-sect-iv"]',
    navText: '[data-anim="side-nav-text-iv"]',
    navTextMaskIn: '[data-anim="side-nav-text-iv"] .mask_in',
    navLine: '[data-anim="side-nav-line-iv"]',
    navLineMaskIn: '[data-anim="side-nav-line-iv"] .mask_in',
  },
}

export default class SideStickySectionTextInViewAnimation {
  $contentRoot = document
  $header = null
  $sections = null

  wh = 0
  headerHeight = 0

  animInfo = []

  constructor(options = {}) {
    deepMerge(this, defaults, options)
  }

  init() {
    this._set$()
    this._setInfo()
    this._setPositions()
    this._addHandlers()
  }

  destroy() {
    this._removeHandlers()
    this.animInfo = []
    this.$sections = null
  }

  _set$() {
    this.$header = document.querySelector(this.$names.header)
    this.$sections = this.$contentRoot.querySelectorAll(this.$names.section)
  }

  _setInfo() {
    this.animInfo = []
    if (this.$sections?.length) {
      this.$sections.forEach(($section, index) => {
        if ($section) {
          const $navTexts = $section.querySelectorAll(this.$names.navText) || []
          const $navTextMaskIns = $section.querySelectorAll(this.$names.navTextMaskIn) || []
          const $navLines = $section.querySelectorAll(this.$names.navLine) || []
          const $navLineMaskIns = $section.querySelectorAll(this.$names.navLineMaskIn) || []

          if ($navTexts.length && $navTextMaskIns.length) {
            this.animInfo.push({
              $section,
              $navTexts,
              $navTextMaskIns,
              $navLines,
              $navLineMaskIns,
              index,
              sectionOffsetTop: 0,
              inViewPos: 0,
              isInView: false,
              isAnimated: false,
              inViewAnimation: () => {
                requestAnimationFrame(() => {
                  if ($navTextMaskIns && $navTextMaskIns.length) {
                    gsap.to($navTextMaskIns, {
                      opacity: 1,
                      duration: 0,
                      stagger: 0.025,
                      delay: 0.2,
                    })
                    gsap.to($navTextMaskIns, {
                      yPercent: 0,
                      force3D: false,
                      duration: 1.3,
                      ease: 'expo.out',
                      stagger: 0.025,
                      delay: 0.2,
                    })
                  }

                  if ($navLineMaskIns && $navLineMaskIns.length) {
                    gsap.to($navLineMaskIns, {
                      opacity: 1,
                      duration: 0,
                      stagger: 0.025,
                      delay: 0.15,
                    })
                    gsap.to($navLineMaskIns, {
                      xPercent: 0,
                      force3D: false,
                      duration: 1,
                      ease: getCubicCurve(0.6, 0.3, 0, 1),
                      stagger: 0.025,
                      delay: 0.15,
                    })
                  }
                })
              },
            })
          }

          if ($navTextMaskIns && $navTextMaskIns.length) {
            gsap.set($navTextMaskIns, {
              yPercent: 100,
              opacity: 0,
              force3D: false,
            })
          }

          if ($navLineMaskIns && $navLineMaskIns.length) {
            gsap.set($navLineMaskIns, {
              xPercent: -100,
              opacity: 0,
              force3D: false,
            })
          }
        }
      })
    }
  }

  _addHandlers() {
    if (Common.raf) {
      Common.raf.addHandler(() => {
        this.onRaf()
      }, this.instanceName)
    }

    if (Common.resize) {
      Common.resize.addHandler(() => {
        this.onResize()
      }, this.instanceName)
    }
  }

  _removeHandlers() {
    if (Common.raf) {
      Common.raf.removeHandler(this.instanceName)
    }

    if (Common.resize) {
      Common.resize.removeHandler(this.instanceName)
    }
  }

  _setPositions() {
    this.wh = window.innerHeight

    if (this.$header) {
      this.headerHeight = this.$header.offsetHeight
    }

    this.animInfo.forEach((info) => {
      info.sectionOffsetTop = getTargetOffsetTop(info.$section)
      info.inViewPos = info.sectionOffsetTop - this.headerHeight
    })
  }

  onResize() {
    this._setPositions()
  }

  onRaf() {
    if (Common.scroll) {
      const scrollY = Common.scroll.currentScroll
      this.animInfo.forEach((info) => {
        if (info.inViewPos <= scrollY) {
          if (!info.isInView) {
            info.isInView = true
            info.inViewAnimation()
          }
        }
      })
    }
  }
}